/** App state: current analysis + file metadata. One subscriber (the UI). */

import type { AnalysisResult, Transaction } from '../lib/types';

export interface LoadedFile {
  result: AnalysisResult;
  fileName: string;
  txnCount: number;
  dateRange: [Date, Date];
  warnings: string[];
  currency: string | null;
}

export class Store {
  private current: LoadedFile | null = null;
  private listeners = new Set<() => void>();

  get loaded(): LoadedFile | null {
    return this.current;
  }

  setLoaded(file: LoadedFile | null): void {
    this.current = file;
    for (const l of this.listeners) l();
  }

  /** Notify subscribers without changing the loaded file (e.g. usage mark changed). */
  touch(): void {
    for (const l of this.listeners) l();
  }

  subscribe(fn: () => void): () => void {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
}

export function toLoadedFile(
  result: AnalysisResult,
  transactions: Transaction[],
  fileName: string,
  warnings: string[],
  currency: string | null,
): LoadedFile {
  const first = transactions[0]!;
  const last = transactions[transactions.length - 1]!;
  return {
    result,
    fileName,
    txnCount: transactions.length,
    dateRange: [first.date, last.date],
    warnings,
    currency,
  };
}
